import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<rect width={16} height={16} rx={1} fill="#000055" /><path d="M5.337 7.619h5.327L8 3.048 5.337 7.619Zm-.769 4.572H8L5.337 7.619H1.905l2.663 4.572Zm3.432 0h3.432l2.663-4.572h-3.431L8 12.191Z" fill="#FF0068" /></svg>;
const ForwardRef = forwardRef(SvgIcon);
export default ForwardRef;